export default __webpack_public_path__ + "static/media/edsg-logo-250.1846ef21.png";